<template>
  <div class="pc-page-settings__data-area">
    <el-button size="small" @click="esIndexResetHandler">重新索引全部数据到ES</el-button>
    <el-button size="small" @click="dbBackupHandler">备份数据库</el-button>
  </div>
</template>

<script>
import api from '@/api/maintenance'
import { operateError } from '@/common/errors'

export default {
  components: {
  },
  methods: {
    esIndexResetHandler () {
      this.$confirm('此操作将重新索引所有数据到Elasticsearch, 索引过程中会造成数据短时间内检索不到, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await api.esIndexReset()
          this.$message({
            type: 'success',
            message: '数据重新索引操作已成功发起'
          })
        } catch (e) {
          operateError(e, '数据重新索引')
        }
      }).catch(() => {
      })
    },
    async dbBackupHandler () {
      try {
        await api.dbBackup()
        this.$message({
          type: 'success',
          message: '备份数据库成功'
        })
      } catch (e) {
        operateError(e, '备份数据库')
      }
    }
  }
}
</script>

<style lang="scss">

</style>
